export var extractId = function extractId(href, regex) {
  var matches = (href || '').match(regex);
  return matches ? matches[1] : false;
};
export var findAncestorWithTagName = function findAncestorWithTagName(node, tagName) {
  while (node && node.tagName !== 'BODY') {
    if (node.tagName === tagName) return node;
    node = node.parentNode;
  }
  return null;
};